import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const Devices = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceDevicesReset',
      isReset: true,
      buttonText: 'Reset All Device Data',
      features: [
        'Remove All Devices'
      ]
    },
    {
      demo: 'practiceDevicesScenario',
      isReset: false,
      buttonText: 'Prepare Devices Section for a Demo',
      features: [
        '1 AED AAS w/ upcoming shipments',
        '1 DR AAS w/ upcoming shipments, 6 stand-alone items'
      ]
    },
    {
      demo: 'practiceDevicesMembership',
      isReset: false,
      buttonText: 'Membership',
      features: [
        '1 AED membership kit'
      ]
    },
    {
      demo: 'practiceDevicesStandAlone',
      isReset: false,
      buttonText: 'Stand Alone Devices',
      features: [
        'Stand Alone Devices'
      ]
    },
    {
      demo: 'practiceDevicesPo',
      isReset: false,
      buttonText: 'ARS (Automatic Replenishment Service)/PO',
      features: [
        '1 AED AAS w/ upcoming shipments',
        '1 DR ARS/PO w/ upcoming shipments'
      ]
    },
    {
      demo: 'practiceDevicesFourInactive',
      isReset: false,
      buttonText: 'Four Inactive Kits',
      features: [
        '1 inactive AED expired',
        '1 inactive AED expiring',
        '1 inactive DR expired/expiring'
      ]
    },
    {
      demo: 'practiceDevicesPoExpiredExpiring',
      isReset: false,
      buttonText: 'ARS/PO with Expired/Expiring Items',
      features: [
        '1 AED ARS/PO expired',
        '1 AED ARS/PO expiring',
        '1 AED ARS/PO expired/expiring'
      ]
    },
    {
      demo: 'practiceDevicesPendingApproval',
      isReset: false,
      buttonText: 'Pending Approval',
      features: [
        '1 AED PO pending approval'
      ]
    },
    {
      demo: 'practiceDevicesExpiredRefill',
      isReset: false,
      buttonText: 'AAS with Expired Items Being Refilled Soon',
      features: [
        '1 AED AAS expired but refilled soon'
      ]
    },
    {
      demo: 'practiceDevicesBackordered',
      isReset: false,
      buttonText: 'AAS Kit with Backordered Items',
      features: [
        '1 AED AAS expired',
        '1 AED AAS expiring',
        '1 AED AAS uptodate'
      ]
    },
    {
      demo: 'practiceDevicesOnHold',
      isReset: false,
      buttonText: 'ARS with On Hold Item',
      features: [
        '1 AED ARS with 1 item on hold'
      ]
    },
    {
      demo: 'practiceDevicesAll',
      isReset: false,
      buttonText: 'Lot of Devices',
      features: [
        '1 DR AAS',
        '1 DR AAS Expired',
        '1 DR AAS Expired w/ Upcoming shipment',
        '1 AED ARS/PO',
        '1 AED ARS/PO Expired',
        '1 AED ARS/PO Expiring',
        '1 AED ARS/PO Expired/Expiring',
        '1 AED Inactive',
        '1 AED Inactive Expired',
        '1 AED Inactive Expiring',
        '1 AED Inactive Expired/Expiring'
      ]
    }
  ]

  return (
    <DemoCard headerText='Devices' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default Devices